import { TransformRotation } from '@ikea-aoa/elements-3d';

export class Quaternion {
	constructor(public x: number, public y: number, public z: number, public w: number) {}

	public toVector(): TransformRotation {
		const result = { x: 0, y: 0, z: 0 } as TransformRotation;

		const qz = this.z;
		const qx = this.x;
		const qy = this.y;
		const qw = this.w;

		const sqw = qw * qw;
		const sqz = qz * qz;
		const sqx = qx * qx;
		const sqy = qy * qy;
		const zAxisY = qy * qz - qx * qw;
		const limit = 0.4999999;

		if (zAxisY < -limit) {
			result.y = 2 * Math.atan2(qy, qw);
			result.x = Math.PI / 2;
			result.z = 0;
		} else if (zAxisY > limit) {
			result.y = 2 * Math.atan2(qy, qw);
			result.x = -Math.PI / 2;
			result.z = 0;
		} else {
			result.z = Math.atan2(2.0 * (qx * qy + qz * qw), -sqz - sqx + sqy + sqw);
			result.x = Math.asin(-2.0 * (qz * qy - qx * qw));
			result.y = Math.atan2(2.0 * (qz * qx + qy * qw), sqz - sqx - sqy + sqw);
		}

		return result;
	}

	public static fromVector(vector: TransformRotation): Quaternion {
		const { x, y, z } = vector;
		const q = new Quaternion(0, 0, 0, 0);
		this.rotationYawPitchRollToRef(y as number, x as number, z as number, q);
		return q;
	}

	public static rotationYawPitchRollToRef(
		yaw: number,
		pitch: number,
		roll: number,
		result: Quaternion
	): void {
		const halfRoll = roll * 0.5;
		const halfPitch = pitch * 0.5;
		const halfYaw = yaw * 0.5;

		const sinRoll = Math.sin(halfRoll);
		const cosRoll = Math.cos(halfRoll);
		const sinPitch = Math.sin(halfPitch);
		const cosPitch = Math.cos(halfPitch);
		const sinYaw = Math.sin(halfYaw);
		const cosYaw = Math.cos(halfYaw);

		result.x = cosYaw * sinPitch * cosRoll + sinYaw * cosPitch * sinRoll;
		result.y = sinYaw * cosPitch * cosRoll - cosYaw * sinPitch * sinRoll;
		result.z = cosYaw * cosPitch * sinRoll - sinYaw * sinPitch * cosRoll;
		result.w = cosYaw * cosPitch * cosRoll + sinYaw * sinPitch * sinRoll;
	}
}
